import apiClient from '../../api/apiClient';

export const getSingleScanApi = async (params) => {
  const { oemId, search = '', userType = '' } = params;
  const response = await apiClient.get('/partners/oem-partners/endUsers/scanList', {
    params: { oemId, search, ...(userType && { userType }) }
  });
  return response.data;
};